import { base, onDarkBase } from "@biom3/design-tokens";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import { Card, Stack, Typography } from "@mui/material";
import { ColoredChip } from "../ColoredChip";
import { GemsChip } from "../GemsChip";

interface QuestCompletionCardProps {
  name: string;
  gameName: string;
  timesCompleted: number;
  totalPointsEarned: number;
  dimmed?: boolean;
}

export const QuestCompletionCard = ({
  name,
  gameName,
  timesCompleted,
  totalPointsEarned,
  dimmed,
}: QuestCompletionCardProps) => {
  return (
    <Card
      variant="outlined"
      sx={{
        p: base.spacing.x4,
        mb: base.spacing.x2,
        borderRadius: onDarkBase.borderRadius.x4,
        background: onDarkBase.color.neutral[700],
        opacity: dimmed ? 0.4 : 1,
      }}
    >
      <Stack direction="column" width="100%" alignItems="flex-start">
        <Stack
          direction="row"
          display="flex"
          width="100%"
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body1" component="div">
            <Stack direction="row" spacing={1}>
              {timesCompleted > 1 && (
                <ColoredChip
                  color="secondary"
                  text={`${timesCompleted}x`}
                  icon={<ElectricBoltIcon />}
                />
              )}
              <strong>{name}</strong>
            </Stack>
          </Typography>

          <GemsChip
            sx={{ mb: 1 }}
            amount={totalPointsEarned}
            completed={!dimmed}
          />
        </Stack>
        <Stack>
          <Typography
            variant="body2"
            sx={{
              color: onDarkBase.color.text.caption.inverse.secondary,
              fontWeight: 500,
            }}
          >
            {gameName || ""}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
